// extracted by mini-css-extract-plugin
export default {"root":"CardWidget_root__+EzhU","list":"CardWidget_list__wodMe","item":"CardWidget_item__3HzqL","itemLink":"CardWidget_itemLink__sxzAu"};